import { CommonModule } from '@angular/common';
import { Component, inject, Inject, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ApiRequestService, DateUtilPipe, DialogService, GoogleTagManagerService, ProductPreviewComponent, ShoppingcartService, SigninComponent, TranslationPipe } from '@prekog/common-ui';
import { Observable } from 'rxjs/internal/Observable';
import { PressarticleComponent } from '../pressarticle/pressarticle.component';
import { Material } from '../shared/material.model';
import { GetPackageOfferOrFallbackRequest, GetPackageOfferOrFallbackUseCase } from './get-package-offer-or-fallback.usecase';
import { GetProfessionalMaterialContentUseCase } from './get-professional-material-content.usecase';
import { GetProfessionalMaterialContentRequest } from './get-professional-material-content.usecase-request';
import { GetProfessionalMaterialContentResponse } from './get-professional-material-content.usecase-response';
import { GetProductRequest } from './getproductrequest';
import { GetProductResponse } from './getproductresponse';
import { GetSerieRequest } from './getserierequest';
import { GetSerieResponse } from './getserieresponse';
import { Serie } from './serie';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'pf-popuptxt',
    templateUrl: './books.component.html',
    styleUrls: ['./books.component.scss'],
    standalone: true,
    imports: [TranslationPipe, FormsModule, CommonModule, DateUtilPipe, MatIconModule, PressarticleComponent, RouterModule, ProductPreviewComponent]
})
export class BooksComponent implements OnInit {
    dialogConfiger: MatDialogConfig = {
        width: '100%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };

    enterAnimationDuration = '500ms';

    exitAnimationDuration = '200ms';

    getProductUrl = '/store/get-product-by-routerlink';

    getSerieUrl = '/store/get-serie-by-id';

    id = 0;

    material?: Material = {};

    objectKeys = Object.keys;

    orderBackendUrl = '';

    packageOfferOrFallback = signal<Material | undefined>(undefined);

    packageOriginalPrice = 0;

    routerLink = '';

    serie: Serie = {};

    storeBackendUrl = '';

    textData = '';

    private _shoppingcartService = inject(ShoppingcartService);

    private _dialogService = inject(DialogService);
    private _getProfessionalMaterialContentUseCase = inject(GetProfessionalMaterialContentUseCase);
    private _getPackageOfferOrFallbackUseCase = inject(GetPackageOfferOrFallbackUseCase);
    private _apiRequestService = inject(ApiRequestService);
    private _googleTagManagerService = inject(GoogleTagManagerService);
    private readonly _domSanitizer = inject(DomSanitizer);
    private readonly _activatedRoute = inject(ActivatedRoute);

    constructor(
        @Inject('ORDER_BACKEND_URL') private _orderBackendUrl: string,
        @Inject('STORE_BACKEND_URL') private _storeBackendUrl: string
    ) {
        this.orderBackendUrl = _orderBackendUrl;
        this.storeBackendUrl = _storeBackendUrl;
    }

    ngOnInit(): void {
        this._activatedRoute.params.subscribe((params) => {
            const routerLink = params['routerLink'] || window.location.href.split('/').pop()?.split('?')[0] || '';
            this.loadProduct(routerLink);
        });
    }

    private loadProduct(routerLink: string): void {
        this.routerLink = routerLink;
        const getProductRequest: GetProductRequest = {
            routerLink: this.routerLink
        };

        this._apiRequestService.sendRequest(this.storeBackendUrl, getProductRequest, true, this.getProductUrl).subscribe((product) => {
            const productResponse = product as GetProductResponse;
            this.material = productResponse.product;
            this.initializeProducts();
            this._googleTagManagerService.viewProductItem(this.material!);
            this.getRandomPackageProduct(this.material?.id);
        });
    }

    getRandomPackageProduct(productId?: number) {
        const request: GetPackageOfferOrFallbackRequest = { productId };
        (this._getPackageOfferOrFallbackUseCase.execute(request) as Observable<Material | undefined>).subscribe(
            (result) => {
                this.packageOfferOrFallback.set(result);
            }
        );

        if (this.material?.serieId) {
            const getSerieRequest: GetSerieRequest = {
                id: this.material.serieId
            };
            this._apiRequestService.sendRequest(this.storeBackendUrl, getSerieRequest, true, this.getSerieUrl).subscribe((response) => {
                const serieResponse = response as GetSerieResponse;
                this.serie = serieResponse.serie!;
            });
        }
    }

    loadSelectedMaterial(selectedMaterial: Material) {
        const request: GetProfessionalMaterialContentRequest = { materialFileName: selectedMaterial.txt as string };
        (this._getProfessionalMaterialContentUseCase.execute(request) as Observable<GetProfessionalMaterialContentResponse>).subscribe(
            (useCaseResponse: GetProfessionalMaterialContentResponse) => {
                selectedMaterial.textData = useCaseResponse.content;
            }
        );
    }

    addToCart(material: Material) {
        if (!sessionStorage.getItem('token') && material.hasPreorder) {
            sessionStorage.setItem('material', JSON.stringify(material));
            this._dialogService.openDialog(SigninComponent);
        } else {
            this._shoppingcartService.addToCart(material);
        }
    }

    initializeProducts() {
        if (this.material?.webshopPriceActive) {
            this.material.oldPrice = this.material.originalPrice;
            this.material.originalPrice = this.material.webshopPrice;
        }
        if (this.material?.discountPriceActive) {
            this.material.oldPrice = this.material.originalPrice;
            this.material.originalPrice = this.material.discountPrice;
        }
        if (this.material?.hasPreorder) {
            this.material.oldPrice = this.material.originalPrice;
            this.material.originalPrice = this.material.preorderPrice;
        }
        //TODO it is because of facebook link that I have used includes not ==, fb puts a token after url
        if (this.routerLink.includes(this.material?.routerLink as string)) {
            if (this.material?.txt) {
                this.material.txt = this._domSanitizer.bypassSecurityTrustHtml(this.material.txt) as string;
            }
        }
    }

    openPdf(bookExtractUrl: string) {
        window.open(bookExtractUrl);
    }
}
